import db from "../db/database";
import { fetchFromBusinessCentral } from "../utils/businessCentralUtils";
import { isOnline } from "./syncService";
import { resolveTipoPagoDesdeCode } from "../utils/tipoDePago";

export const syncFormasDePago = async () => {
	if (!isOnline()) {
		return false;
	}

	try {
		// Obtener formas de pago del servidor
		const serverFormasDePago = await fetchFromBusinessCentral("FormasPago", "Tpv eq true");

		// Borrar todas las formas de pago locales
		await db.formasPago.clear();

		// Añadir las formas de pago del servidor
		for (const serverFormaPago of serverFormasDePago) {
			const code = serverFormaPago.Code || serverFormaPago.CodFormaPago;
			await db.formasPago.add({
				No: serverFormaPago.No,
				Code: code,
				Description: serverFormaPago.Description || serverFormaPago.Descripcion,
				Dto: serverFormaPago.Dto || 0,
				Tipo_Pago: serverFormaPago.Tipo_Pago || resolveTipoPagoDesdeCode(code),
				lastSynced: new Date(),
			});
		}

		return true;
	} catch (error) {
		console.error("Error al sincronizar formas de pago:", error);
		return false;
	}
};
